module.exports = __webpack_public_path__ + "static/media/celery.d48c66e0.png";